import React from "react";
import {
    TableCell,
    TableRow,
    Box,
    Grid,
    Collapse,
} from '@mui/material';

const CdsnDetailssummary = (props) => {
    const { row, columns, open } = props;

    return <TableRow>
        <TableCell style={{ padding: 0, margin: 0, border: 0 }} colSpan={columns.length + 1}>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box className={'row-details'} padding={2} paddingTop={4} paddingBottom={3} style={{ backgroundColor: "#eceef8" }} >
                    <Grid container justifyContent='space-between' spacing={2}>
                        <Grid item container spacing={0} xs={12} className='grid-block-section'>
                            {
                                props?.module === "cdsndetails-welcomescreen" && <>
                                    <Grid item xs={3} className="mt-3">
                                        <div><span className='row-summary-title'>Brand Video Reboot Counter:</span> {row.roomDetailResponse?.at(0)?.brandVideoBootCounter === -1 ? 'Always' : row.roomDetailResponse?.at(0)?.brandVideoBootCounter}</div>
                                    </Grid>
                                    <Grid item xs={3} className="mt-3">
                                        <div><span className='row-summary-title'>Brand Video Standby Counter:</span> {row.roomDetailResponse?.at(0)?.brandVideoStandByCounter === -1 ? 'Always' : row.roomDetailResponse?.at(0)?.brandVideoStandByCounter}</div>
                                    </Grid>
                                    <Grid item xs={3} className="mt-3">
                                        <div><span className='row-summary-title'>Welcome Image Reboot Counter:</span> {row.roomDetailResponse?.at(0)?.welcomeLetterBootCounter === -1 ? 'Always' : row.roomDetailResponse?.at(0)?.welcomeLetterBootCounter}</div>
                                    </Grid>
                                    <Grid item xs={3} className="mt-3">
                                        <div><span className='row-summary-title'>Welcome Image Standby Counter:</span> {row.roomDetailResponse?.at(0)?.welcomeLetterStandByCounter === -1 ? 'Always' : row.roomDetailResponse?.at(0)?.welcomeLetterStandByCounter}</div>
                                    </Grid>
                                    <Grid item xs={3} className="mt-3">
                                        <div><span className='row-summary-title'>Video Loop Count:</span> {row?.videoLoopCount}</div>
                                    </Grid>
                                </>
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Collapse>
        </TableCell>
    </TableRow>
}

export default CdsnDetailssummary;